import { GET_DELEGATE_ALL_B2B_MEETING_ACTION_TYPE,UPDATE_DELEGATE_ALL_B2B_MEETING_ACTION_TYPE,GET_DELEGATE_B2B_USER_ACTION_TYPE } from "../../../utils/constants";


const initialState = [];

function delegate_All_B2B_Meeting_Reducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_DELEGATE_ALL_B2B_MEETING_ACTION_TYPE:
            return [...state, payload];
        case GET_DELEGATE_B2B_USER_ACTION_TYPE:
            return [...state, payload];
        case UPDATE_DELEGATE_ALL_B2B_MEETING_ACTION_TYPE:
            return [...state, payload];

        default:
            return state;
    }
};

export default delegate_All_B2B_Meeting_Reducer;